import { mapGetters, mapMutations } from "vuex";

export const productTypeNavigation = {
  computed: {
    ...mapGetters({
      getSubNavItem: "navigation/getCurrentSubNavItem"
    })
  },
  methods: {
    setSubNavItemWithFilter(subNavItem) {
      this.setSubNavItem(subNavItem);
      this.setFieldByKeyValue({ key: "type", value: subNavItem });
    },
    ...mapMutations({
      setSubNavItem: "navigation/setCurrentSubNavItem",
      setFieldByKeyValue: "filters/setFieldByKeyValue"
    })
  }
};
